import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CTA from "../components/cta";
const PAGE_SIZE = 4;

function OurTeam() {
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";
  const [listings, setListings] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [sortBy] = useState("id DESC");

  const fetchListings = async (pageNo, isLoadMore = false) => {
    setLoading(true);

    try {
      const res = await fetch(`${API}/api/teamapi.ashx`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          page: pageNo,
          pageSize: PAGE_SIZE,
          sortBy
        })
      });

      const result = await res.json();

      if (result.result === 1) {
        setTotal(result.total || 0);

        setListings(prev =>
          isLoadMore ? [...prev, ...(result.data || [])] : result.data || []
        );

        setHasMore(pageNo * PAGE_SIZE < (result.total || 0));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // initial load
  useEffect(() => {
    fetchListings(1, false);
  }, []);

  const handleLoadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchListings(nextPage, true);
  };
const getLanguageFlag = (language) => {
  const name = language.trim().toLowerCase();

  const flags = {
    english: "/images/flags/uk.svg",
    french: "/images/flags/french.svg",
    swedish: "/images/flags/sweden.svg",
    arabic: "/images/flags/uae.svg",
    hindi: "/images/flags/india.svg",
    urdu: "/images/flags/pakistan.svg",
    russian: "/images/flags/russia.svg",
    chinese: "/images/flags/china.svg",
    italian: "/images/flags/italy.svg", 
    finnish: "/images/flags/finnish.svg", 
  };

  return flags[name] || "/images/flags/globe.svg";
};

  return (
    <>
      <img src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/e8035bc2-179f-4a24-93fa-946c42700b00/w=2200,sharpen=1" width="100%" />

      <section className="team-section">
        <div className="team-container">
         <div className="team-header">
  <h2>Discover our properties by agents </h2>
  <p>
    Looking for trusted real estate agents? Our licensed agents in
    the UAE offer expert guidance for buying, selling, or renting properties.
    Whether you're searching for real estate agents near me or need local market
    insights, we're here to help.{" "}
  </p>
</div>

          <div className="team-grid">
            {listings.map((item, index) => (
              <div className="team-card" key={item.id || index}>
                <div className="team-img">
                  <img
                    src={item.Image+"/w=400,sharpen=1" || "assets/images/agent1.webp"}
                    alt={item.fullname}
                  />

                  <div className="team-social">
                   <Link
  to={item.url}
>
                      <i className="icon icon-search" />
                    </Link>
                  </div>
                </div>

               <div className="team-info">
  <h3>{item.fullname}</h3>
  <p className="padding14">{item.designation}</p>
 <h4 className="team-areah4">Languages:</h4>
<p className="team-area"> {item.Languages}</p> 
<h4 className="team-areah4">Specialized Areas:</h4>
  <p className="team-area"> {item.SpecializedAreas}</p>
</div>

              </div>
            ))}
          </div>

           {/* LOAD MORE BUTTON */}
            {hasMore && (
              <div className="text-center mt-4">
                <button className="tf-btn-full btn-line" onClick={handleLoadMore} disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Loading...
                    </>
                  ) : (
                    "Load More"
                  )}
                </button>
              </div>
            )}
        </div>
      </section>
       <style
    dangerouslySetInnerHTML={{
      __html:
        "\n        .team-section {\n          padding: 25px 20px;\n        }\n\n        .team-container {\n          max-width: 1200px;\n          margin: auto;\n        }\n\n        .team-header {\n          text-align: center;\n          margin-bottom: 60px;\n        }\n\n        .team-header h2 {\n          font-size: 38px;\n          margin-bottom: 10px;\n        }\n\n        .team-header p {\n          color: #666;\n        }\n\n        .team-grid {\n          display: grid;\n          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n          gap: 30px;\n        }\n\n        .team-card {\n          background: #fff;\n          border-radius: 15px;\n          overflow: hidden;\n          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n          transition: 0.3s;\n        }\n\n        .team-card:hover {\n          transform: translateY(-8px);\n        }\n\n        .team-img {\n          position: relative;\n        }\n\n        .team-img img {\n          width: 100%;\n          height: 320px;\n          object-fit: cover;\n          display: block;\n        }\n\n        .team-social {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n          background: rgba(0, 0, 0, 0.55);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 15px;\n          opacity: 0;\n          transition: 0.3s;\n        }\n\n        .team-img:hover .team-social {\n          opacity: 1;\n        }\n\n        .team-social a {\n          width: 40px;\n          height: 40px;\n          background: white;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          text-decoration: none;\n          color: #000;\n          font-weight: 600;\n          transition: 0.3s;\n        }\n\n        .team-social a:hover {\n          background: #000;\n          color: #fff;\n        }\n\n        .team-info {\n          text-align: center;\n          padding: 20px;\n        }\n\n        .team-info h3 {\n          margin-bottom: 5px;\n          font-size: 20px;\n        }\n\n        .team-info span {\n          color: #000000;\n          font-size: 12px;\n        }\n\n        @media(max-width:768px) {\n          .team-header h2 {\n            font-size: 28px;\n          }\n        }\n      "
    }}
  />
  <CTA/>
    </>
  );
}

export default OurTeam;